<template>
  <v-layout row justify-end>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-btn slot="activator" color="primary" light >Sign In</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Sign In</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Email*" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Password*" type="password" required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click="dialog = false">Sign In</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
  }),

  computed: {
    ...mapGetters([
      'signin_dialog']),

    dialog: {
      get() {
        return this.signin_dialog;
      },

      set(val) {
        this.show_signin_dialog(val);
      },

    },
  },

  methods: {
    ...mapMutations([
      'show_signin_dialog',
    ]),

  },
};
</script>
